import React from 'react';

import Button from '@material-ui/core/Button';
import { Icon, Typography, useMediaQuery, Dialog, DialogTitle, DialogActions, DialogContent } from '@material-ui/core';

import ShippingDetailV2 from './ShippingDetailV2';

import { makeStyles } from '@material-ui/core/styles';

import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
    root: {
        'text-plain': {

        },
        [theme.breakpoints.down('sm')]: {
            width: "100%",
        },
    },
    alert: {
        background: theme.palette.colors.fillStroke[300],
        '& .MuiAlert-icon': {
            alignItems: 'center',
            fontSize: 16
        }
    },
    modalTitle: {
        padding: "24px 24px 0 24px"
    },
    modalContainer: {
        padding: "16px 24px 24px 24px"
    },
    modal: {
        [theme.breakpoints.down('sm')]: {
            paddingBottom: "40px",
            paddingTop: "1px"
        },
    },
    shippingGuideButton: {
        [theme.breakpoints.down('sm')]: {
            marginTop: "18px"
        }
    }
}));

export default function ShippingBttnV2({ styleLearning, templateId, onSuccess}) { // Destructure props
    const classes = useStyles();
    const isResponsive = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const [showShippingDetail, setShowShippingDetail] = React.useState(false);

    const handleCloseShippingDetail = () => {
        setShowShippingDetail(false);
    }

    const handleOpenShippingDetail = () => {
        setShowShippingDetail(true);
    }

    return (
        <>
            <div className={classes.root} id="shipping-bttn-root">
                <Button
                    variant="outlined"
                    color="primary"
                    className={clsx('electric-green', classes.shippingGuideButton)}
                    onClick={handleOpenShippingDetail}
                    endIcon={<Icon className='ri-arrow-right-line' />}
                    fullWidth={isResponsive}>
                    Ver instrucciones
                </Button>
            </div>

            <Dialog open={showShippingDetail} className={clsx(classes.modal, 'shipping-detail-modal')}>
                <DialogTitle className={classes.modalTitle}>
                    <Typography variant='h4' fontSize="20px">¿Cómo entregar tus documentos originales?</Typography>
                </DialogTitle>
                <DialogContent className={classes.modalContainer}>
                    <ShippingDetailV2 learningStyle={styleLearning} templateId={templateId} onSuccess={onSuccess} onClosed={handleCloseShippingDetail} /> {/* Pass props correctly */}
                </DialogContent>
                <DialogActions>
                    <>
                        <Button onClick={handleCloseShippingDetail} color="primary" variant='contained'>
                            Volver
                        </Button>
                    </>
                </DialogActions>
            </Dialog>
        </>
    );
}
